import { Request } from '@group-devs/yfp7-global-modules'
import { getUrl } from '@group-devs/yfp7-global-modules/utils/general'
import Authenticator from '@group-devs/yfp7-authenticator'

function ensureAuthProps(authProps) {
    if (!authProps) {
        // Return a default auth object with all required properties
        return {
            auth: {
                isAuthenticated: false,
                site_owner: false,
                site_user: false,
                userId: null,
                contactId: null,
            }
        };
    }
    
    // If authProps exists but some properties are missing, add them
    if (!authProps.auth) {
        authProps.auth = {};
    }
    
    // Ensure all required properties exist
    authProps.auth.isAuthenticated = authProps.auth.isAuthenticated || false;
    authProps.auth.site_owner = authProps.auth.site_owner || false;
    authProps.auth.site_user = authProps.auth.site_user || false;
    authProps.auth.userId = authProps.auth.userId || null;
    authProps.auth.contactId = authProps.auth.contactId || null;
    
    return authProps;
}


async function initialProps(req, res, query, path=false) {
    let token, cookie, authenticator, request, metaData, authProps, graphProps, pageProps, sitesProps, countryCode, props = {};
    
    try {
        authenticator = new Authenticator(req, res, process.env);
        request = new Request(process.env.apiDomain);
        const sessionName = authenticator.env.AUTH_SERVER_SESSION_NAME;

        // set CSRF metadata
        metaData = authenticator.setCsrf();

        if (typeof req !== "undefined") {
            props.host = req.headers.host;
            // props.path = req.url
        } else {
            props.host = window.location.hostname;
            // props.path = window.location.pathname
        }

        // set initial authentication cookie
        try {
            token = await authenticator.getToken();
        } catch (tokenError) {
            console.error("Error getting token:", tokenError);
            token = null;
        }
        
        props.path = path ? path : null;
        props.query = query ? query : null;
        
        console.log('req:',req.headers);
        console.log('host:',req.headers.host);

        // Get initial website data
        graphProps = await request.website.siteData(getUrl(props.host, props.path));
        
        console.log('graphProps:',graphProps);
        
        // Get list of active country list for country code
        countryCode = await request.core.countries({is_active : 1});

        if (graphProps.site && graphProps.site.site.code == "WC")
            pageProps = await request.website.pageData(getUrl(props.host, path));
        
        console.log('pageProps:',pageProps);

        // Site Urls
        sitesProps = graphProps.site ? await request.website.siteUrls(graphProps.site.accountId, ["HUB","WC", "BC", "7BS", "7WAYS"]) : null;

        let reload = {reload: false};
        let contact_user = false;
        let downline_user = false;
        let contact_check_obj = [];

        // check cookie if site_user
        let contact_check = authenticator.getTokenCookie(sessionName);
        if (typeof contact_check !== 'undefined') {
            try {
                contact_check_obj = JSON.parse(Buffer.from(contact_check, 'base64').toString());
                contact_user = contact_check_obj.auth?.site_user || false;
                downline_user = contact_check_obj.auth?.site_downline || false;
            } catch (parseError) {
                console.error("Error parsing contact_check:", parseError);
                contact_user = false;
                downline_user = false;
            }
        }

        if (contact_user) {
            if (authenticator.env.CONTACT_ALLOWED == 1) {
                try {
                    authProps = JSON.parse(Buffer.from(contact_check, 'base64').toString());
                } catch (parseError) {
                    console.error("Error parsing contact_check for authProps:", parseError);
                    authProps = authenticator.setUnauthenticationSession(true);
                }
            } else {
                authProps = authenticator.setUnauthenticationSession(true);
            }
        } else {
            if (authenticator.verifyToken(token)) {
                // set authentication cookie if token exists from the authentication server
                authenticator.setSessionCookie(true, sessionName);
                cookie = authenticator.getTokenCookie(sessionName);
                if (typeof cookie === "undefined") {
                    // set initial authentication cookie if token returns false
                    authProps = authenticator.setAuthenticationSession();
                } else {
                    try {
                        authProps = JSON.parse(Buffer.from(cookie, "base64").toString());
                    } catch (parseError) {
                        console.error("Error parsing cookie:", parseError);
                        authProps = authenticator.setAuthenticationSession();
                    }
                }
            } else {
                try {
                    const authInfo = await authenticator.checkAuthUser(req);
                    if (authInfo?.token) {
                        authenticator.setTokenCookie(authInfo.user_id, 'user_id');
                        authenticator.setTokenCookie(authInfo.contact_id, 'contact_id');
                        authenticator.setSessionCookie(true, process.env.AUTH_SERVER_SESSION_NAME);

                        cookie = authenticator.getTokenCookie(sessionName);

                        if (typeof cookie === "undefined") {
                            // set initial authentication cookie if token returns false
                            authProps = authenticator.setAuthenticationSession();
                        } else {
                            authProps = JSON.parse(Buffer.from(cookie, "base64").toString());
                        }

                        if (!authProps.auth?.isAuthenticated) {
                            reload = { 
                                reload: {
                                    reload: true,
                                }
                            };
                        }
                    } else {
                        cookie = authenticator.getTokenCookie(sessionName);
                        if (typeof cookie === "undefined") {
                            // set initial authentication cookie if token returns false
                            authProps = authenticator.setAuthenticationSession();
                        } else {
                            authProps = JSON.parse(Buffer.from(cookie, "base64").toString());
                        }
                            
                        if (authProps.auth?.isAuthenticated) {
                            let ref = await authenticator.autoCheckSession(authProps.auth.site_domain, authProps.auth.site_user_email);
                            if (typeof ref != 'undefined' && ref != false) {
                                let data = {
                                    domain: graphProps.site.url, 
                                    ref: Buffer.from(ref, "base64").toString(),
                                    websiteId: graphProps.site.websiteId,
                                };

                                let _response = await authenticator.autoLogin(data);

                                if (typeof _response === 'object') {
                                    if (_response.code === 200) {
                                        if (typeof cookie === "undefined") {
                                            // set initial authentication cookie if token returns false
                                            authProps = authenticator.setAuthenticationSession();
                                        } else {
                                            authProps = JSON.parse(Buffer.from(cookie, "base64").toString());
                                        }
                                    } else {
                                        // set initial authentication cookie if token returns false
                                        authenticator.removeTokenCookie(process.env.AUTH_SERVER_COOKIE_NAME);
                                        authenticator.removeTokenCookie(process.env.AUTH_SERVER_SESSION_NAME);
                                        authProps = authenticator.setUnauthenticationSession();
                                    }
                                } else {
                                    // set initial authentication cookie if token returns false
                                    authenticator.removeTokenCookie(process.env.AUTH_SERVER_COOKIE_NAME);
                                    authenticator.removeTokenCookie(process.env.AUTH_SERVER_SESSION_NAME);
                                    authProps = authenticator.setUnauthenticationSession();
                                }
                            } else {
                                // set initial authentication cookie if token returns false
                                authenticator.removeTokenCookie(process.env.AUTH_SERVER_COOKIE_NAME);
                                authenticator.removeTokenCookie(process.env.AUTH_SERVER_SESSION_NAME);
                                authProps = authenticator.setUnauthenticationSession();
                            }
                        } else {
                            let ref = await authenticator.autoCheckSessionMainDomain();
                            if (typeof ref != 'undefined' && ref != false) {
                                let data = {
                                    domain: graphProps.site.url, 
                                    ref: Buffer.from(ref, "base64").toString(),
                                    websiteId: graphProps.site.websiteId,
                                };

                                let _response = await authenticator.autoLogin(data);
                                if (typeof _response === 'object') {
                                    if (_response.code === 200) {
                                        reload = { 
                                            reload: {
                                                reload: true,
                                                refHash: Buffer.from(ref, "base64").toString()
                                            }
                                        };

                                        authenticator.setTokenCookie(_response.token, process.env.AUTH_SERVER_COOKIE_NAME);
                                        authenticator.setSessionCookie(true, process.env.AUTH_SERVER_SESSION_NAME);
                                        cookie = authenticator.getTokenCookie(process.env.AUTH_SERVER_SESSION_NAME);

                                        if (typeof cookie === "undefined") {
                                            // set initial authentication cookie if token returns false
                                            authProps = authenticator.setAuthenticationSession();
                                        } else {
                                            authProps = JSON.parse(Buffer.from(cookie, "base64").toString());
                                        }
                                    } else {
                                        // set initial authentication cookie if token returns false
                                        authenticator.removeTokenCookie(process.env.AUTH_SERVER_COOKIE_NAME);
                                        authenticator.removeTokenCookie(process.env.AUTH_SERVER_SESSION_NAME);
                                        authProps = authenticator.setUnauthenticationSession();
                                    }
                                } else {
                                    // set initial authentication cookie if token returns false
                                    authenticator.removeTokenCookie(process.env.AUTH_SERVER_COOKIE_NAME);
                                    authenticator.removeTokenCookie(process.env.AUTH_SERVER_SESSION_NAME);
                                    authProps = authenticator.setUnauthenticationSession();
                                }
                            } else {
                                // set initial authentication cookie if token returns false
                                authenticator.removeTokenCookie(process.env.AUTH_SERVER_COOKIE_NAME);
                                authenticator.removeTokenCookie(process.env.AUTH_SERVER_SESSION_NAME);
                                authProps = authenticator.setUnauthenticationSession();
                            }
                        }
                    }
                } catch (authError) {
                    console.error("Error in authentication flow:", authError);
                    authProps = authenticator.setAuthenticationSession();
                }
            }
        }

        const accountId = graphProps.site && graphProps.site.accountId ? graphProps.site.accountId : '';
        const site_id = graphProps.site && graphProps.site.id ? parseInt(graphProps.site.id) : '';

        const adPixel = graphProps.site ? await request.insights.pixel(accountId, {site_id:site_id}) : {};

        //Default Country
        let country = 'us';

        // Get the country Cookie
        const countryCookie = authenticator.getTokenCookie('country');

        if (typeof countryCookie !== "undefined") {
            if (countryCookie == "ca") {
                country = countryCookie;
            }
        }

        // Ensure authProps is properly initialized with required fields
        if (typeof authProps === 'undefined') {
            authProps = ensureAuthProps(null);
        } else {
            authProps = ensureAuthProps(authProps);
        }
        
        props = { 
            ...props, 
            ...graphProps, 
            ...pageProps, 
            ...authProps, 
            ...metaData, 
            ...reload, 
            defaultCountryCode: countryCode, 
            sites: sitesProps, 
            adPixel: adPixel,
            country: country
        };

        console.log("initialProps:", props);

        if (typeof props.err !== "undefined") {
            res.statusCode = props.err.code;
        }
        
        return props;
        
    } catch (error) {
        console.error("Critical error in initialProps:", error);
        // Create minimal props with error information
        props = { 
            ...props,
            auth: {
                isAuthenticated: false,
                site_owner: false,
                site_user: false,
                userId: null,
                contactId: null
            },
            err: { 
                code: 500, 
                message: "Internal server error" 
            }
        };
        
        if (res) {
            res.statusCode = 500;
        }
        
        return props;
    }
}

async function categoryProps(req, res, query)
{
    let request = new Request(process.env.apiDomain)

    let props = await initialProps(req, res, query)

    if (typeof props.err !== "undefined")
        return props

    let category = await request.content.category("wellness-center", query.slug)

    if (typeof category.err !== "undefined")
    {
        props.err = category.err
        res.statusCode = props.err.code
    }

    props.category = category

    return props
}

async function articleProps(req, res, query)
{
    
    let request = new Request(process.env.apiDomain)

    var props = await initialProps(req, res, query)

    if (typeof props.err !== "undefined")
        return props

    let article = await request.content.article(query.slug,props.country)

    if (typeof article.err !== "undefined")
    {
        props.err = article.err
        res.statusCode = props.err.code
    }

    props.article = article

    return props
}

async function newsletterProps(req, res, query)
{
    let request = new Request(process.env.apiDomain)

    var props = await initialProps(req, res, query)

    if (typeof props.err !== "undefined")
        return props

    let newsletters = await request.ems.newsletters(props.site.accountId)

    if (typeof newsletters.err !== "undefined")
    {
        props.err = newsletters.err
        res.statusCode = props.err.code
    }

    props.newsletters = newsletters

    return props
}

async function newsletterDetailsProps(req, res, query)
{
    let request = new Request(process.env.apiDomain)

    var props = await initialProps(req, res, query)

    if (typeof props.err !== "undefined")
        return props

    let newsletterDetails = await request.ems.newsletterDetails(parseInt(query.slug))

    if (typeof newsletterDetails.err !== "undefined")
    {
        props.err = newsletterDetails.err
        res.statusCode = props.err.code
    }

    props.newslettersDetails = newsletterDetails

    return props
}

export { initialProps, categoryProps, articleProps, newsletterProps, newsletterDetailsProps }